import { SelectListItem } from "@/services/models/shared/SelectListItem";

export class EnumExtensions {
  EnumToSelectList(enumType: any) : Array<SelectListItem> {
    return (Object.keys(enumType).filter(x => isNaN(parseInt(x)))).map((key) => {
      const enumVal = enumType[key]
      return {
        value: enumVal,
        text: key
      } as SelectListItem;
    });
  }
}

export default new EnumExtensions();